import { PublicClientApplication } from "@azure/msal-browser"
import { MsalProvider } from "@azure/msal-react"
import { createBrowserHistory } from "history"
import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux"
import { Router } from "react-router-dom"
import { authSettings as msalConfig } from "./Config"
import App from "./containers/App/index"
import "./index.css"
import * as serviceWorker from "./serviceWorker"
import "./static/css/all.css"
import "./static/css/custom.css"
import "./static/css/mdb.css"
import store from "./store"

const msalInstance = new PublicClientApplication(msalConfig)
const customHistory = createBrowserHistory()
const root = createRoot(document.getElementById("root")); // createRoot(container!) if you use TypeScript

root.render(
    <Router history={customHistory}>
        <Provider store={store}>
            <MsalProvider instance={msalInstance}>
                <App />
            </MsalProvider>
        </Provider>
    </Router>,
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
